import React from "react";
import PressDetailPresenter from "./PressDetailPresenter";
import { useParams, useNavigate } from "react-router-dom";
import { useScrollTop, usePressDetail } from '../../hooks';

const PressDetailContainer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: pressDetail } = usePressDetail(id);

  const handleBack = () => navigate(-1);

  useScrollTop();

  if (!pressDetail) return null;

  return (
    <PressDetailPresenter 
      pressDetail={pressDetail} 
      handleBack={handleBack} 
    />
  );
};

export default PressDetailContainer;
